
export function searchListGet(page, timestamp, callback) {
	return {
    type: 'SEARCH_LIST_GET',
		payload: {
			page: page,
			timestamp: timestamp,
		},
		callback: callback,
	}
}

export function searchConditionListGet() {
	return {
    type: 'SEARCH_CONDITION_LIST_GET',
	}
}

export function searchConditionSave(conditionName, condition) {
	return {
    type: 'SEARCH_CONDITION_SAVE',
		payload: {
			conditionName: conditionName,
			condition: condition,
		},
	}
}


export function searchConditionDel(id) {
	return {
    type: 'SEARCH_CONDITION_ITEM_DEL',
		payload: {
			id: id,
		},
	}
}

export function searchScrollposEdit(scrollpos) {
	return {
    type: 'SEARCH_SCROLLPOS_SET',
		payload: {
			scrollpos: scrollpos,
		},
	}
}

export function searchCondionButtonBalloonEdit(bool) {
	return {
    type: 'SEARCH_CONDITION_BUTTON_BALLOON_SET',
		payload: {
			bool: bool,
		},
	}
}
